export default class FontConstants {
  public static readonly SUBHEADING_WEIGHT = 700;
  public static readonly TITLE_FONT_SIZE = 40;
}
